import { render, staticRenderFns } from "./failed-insurance.vue?vue&type=template&id=446f6e3c&"
import script from "./failed-insurance.vue?vue&type=script&lang=js&"
export * from "./failed-insurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports